import React, { useContext } from "react";
import PlanningMapList from "./PlanningMapList";
import VenueCapacityFilter from "components/filters/Filters/VenueCapacityFilter";
import VenueCategoryFilter from "components/filters/Filters/VenueCategoryFilter";
import { VenueForMap } from "./VenueForMap";
import TagFilter from "components/filters/Filters/TagFilter";
import FilterValue from "components/filters/FilterValue";
import FilterAndValue from "components/filters/FilterAndValue";
import { DisplayMode } from "./PlanningMapApp";
import { getListUniqueKey } from "./planningMapHelpers";
import { FilterContext } from "components/filters/FilterContext";
import PlanningMapVirtualizedListItem from "./PlanningMapVirtualizedListItem";
import { GoogleMapVenuePinForMapList } from "components/GoogleMap/pins/PinForList";

interface Props {
  tags: server.dto.TagSmall[]
  venues: server.dto.VenueForPlanningMap[]
  selectedVenues: server.dto.VenueForPlanningMap[]
  total: number
  hoveredVenues: server.dto.VenueForPlanningMap[]
  isLayerSelected: boolean
  onLayerToggle: () => void
  displayMode: DisplayMode
  isInitialLoading: boolean
  error?: string
  onDisplayModeChange: (displayMode: DisplayMode) => void
  onViewAllClick: () => void
  onPreviewPanelOpen: (item: server.dto.VenueForPlanningMap) => void
  onHover: (venue: server.dto.VenueForPlanningMap) => void
  isFetching: boolean
}

const VenueRenderer = (props: { data: Props, index: number, style: React.CSSProperties }) => {
  const venue = props.data.venues[props.index];
  return <PlanningMapVirtualizedListItem {...props}>
    <VenueForMap
      onOpen={() => props.data.onPreviewPanelOpen(venue)}
      hovered={props.data.hoveredVenues.findIndex(v => v.venueId === venue.venueId) !== -1}
      selected={props.data.selectedVenues.includes(venue)}
      venue={venue}
      onHover={props.data.onHover}
    />
  </PlanningMapVirtualizedListItem>
}

const PlanningMapVenueList = (props: Props) => {
  const { isDefault } = useContext(FilterContext);

  return <PlanningMapList
    displayMode={props.displayMode}
    onDisplayModeChange={props.onDisplayModeChange}
    uniqueId={getListUniqueKey("venue")}
    rowHeight={64} // This should be the height of VenueForMap + 4px for the item spacing
    isLayerSelected={props.isLayerSelected}
    onLayerToggle={props.onLayerToggle}
    onViewAllClick={props.onViewAllClick}
    title={site.currentEnvironment.functionGroups.venue.plural}
    total={props.total}
    pin={<GoogleMapVenuePinForMapList />}
    hasFilters={!isDefault}
    isInitialLoading={props.isInitialLoading}
    error={props.error}
    numberOfRows={props.venues.length}
    itemData={props}
    renderer={VenueRenderer}
    selectedItems={props.selectedVenues}
    isFetching={props.isFetching}
  >
    <FilterAndValue>
      <VenueCapacityFilter maxCapacity={serverReference.constants.venue.maxCapacity} />
      <FilterValue filterKey="venueCapacity" />
    </FilterAndValue>

    <FilterAndValue>
      <VenueCategoryFilter />
      <FilterValue filterKey="venueCategory" />
    </FilterAndValue>

    <FilterAndValue>
      <TagFilter mainArea="company" initialTags={props.tags} />
      <FilterValue filterKey="tags" />
    </FilterAndValue>

  </PlanningMapList>
}

export default PlanningMapVenueList;